var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 1025,
    viewBox: "0 0 656 1025",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377.297 242.881C377.297 376.869 292.838 485.263 188.898 485.263C84.9585 485.263 0.5 376.869 0.5 242.881C0.5 108.894 84.9585 0.5 188.898 0.5C292.838 0.5 377.297 108.894 377.297 242.881Z",
    stroke: "white",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M655.5 421.295C655.5 555.283 571.041 663.676 467.101 663.676C363.162 663.676 278.703 555.283 278.703 421.295C278.703 287.307 363.162 178.914 467.101 178.914C571.041 178.914 655.5 287.307 655.5 421.295Z",
    stroke: "white",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.394 898.062C142.394 898.062 177.813 611.529 316.929 767.771C456.045 924.012 456.398 882.001 479.859 827.332",
    stroke: "white",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.394 1024C142.394 1024 177.813 737.468 316.929 893.709C456.045 1049.95 456.398 1007.94 479.859 953.271",
    stroke: "white",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIcons);
export default __webpack_public_path__ + "static/media/background-icons.866483142b421a032ddb94bd78d09a72.svg";
export { ForwardRef as ReactComponent };